import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { href: "#comment-ca-marche", label: "Comment ça marche" },
  { href: "#services", label: "Services" },
  { href: "#simulateur", label: "Simulateur" },
  { href: "#rendez-vous", label: "Rendez-vous" },
  { href: "#avis", label: "Avis" },
  { href: "#faq", label: "FAQ" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur transition-all ${
        scrolled ? "border-b border-slate-200 shadow-sm" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="header-logo">
          <Logo variant="dark" size="md" />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-slate-700 hover:text-spi-blue transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Button
            asChild
            variant="ghost"
            data-testid="header-cta-contact"
            className="text-spi-blue font-medium"
          >
            <a href="#contact">Contact</a>
          </Button>
          <Button
            asChild
            data-testid="header-cta-simulateur"
            className="bg-spi-blue hover:bg-spi-blue-dark text-white rounded-md font-semibold"
          >
            <a href="#simulateur">Vérifier mes subsides</a>
          </Button>
        </div>

        <button
          data-testid="header-burger"
          className="lg:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-slate-700 text-sm font-medium"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#simulateur"
              onClick={() => setOpen(false)}
              data-testid="header-mobile-cta"
              className="bg-spi-blue text-white text-center rounded-md py-2 text-sm font-semibold"
            >
              Vérifier mes subsides
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
